import { DialogTitleCaption, styled } from '@/core/ui';
export const InnerContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(4),
}));
export const BalanceLabel = styled(DialogTitleCaption)(({ theme }) => ({
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
    marginLeft: theme.spacing(4),
    color: theme.palette.text.muted,
}));
